export default __webpack_public_path__ + "static/UNA_CARNE_ASADA-c1d7ff1b245d74a461e16bf43c71f6ba.jpg";